import React from "react";
import Logo from "./Logo";

type Props = {};

const LeftSection = (props: Props) => {
  return <Logo />;
};

export default LeftSection;
